/* 
 * Javier Quevedo-Fernandez
 * Copyright Ranj Games. 2013
 */

export default class BackgroundOverlayStyle {
    constructor(color, alpha) {
        this.color = color;
        this.alpha = alpha;
    }
}